import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { switchMap, tap } from "rxjs/operators";
import { PriceChangeService } from "../price-change-service";
import { Page } from "src/app/util/page";
import { PriceChange, PriceChangeStatus } from "../model/price-change";
import { Observable } from "rxjs";
import { SupplierReference } from "../../reference/supplier-reference";

@Component({
  styleUrls: ["./price-changes.component.css"],
  templateUrl: "./price-changes.component.html"
})
export class PriceChangesComponent {
  PriceChangeStatus = PriceChangeStatus;
  
  statuses = [PriceChangeStatus.TO_PROCESS];

  priceChanges?: Page<PriceChange>;
  processing = false;

  constructor(
    private priceChangeService: PriceChangeService,
  ) {
    this.refresh().subscribe();
  }

  updateStatus(id: string, status: PriceChangeStatus) {
    this.processing = true;
    
    this.priceChangeService.updateStatus(id, status)
      .pipe(switchMap(_ => this.refresh()))
      .subscribe({
        complete: () => this.processing = false
      });
  }

  refresh(): Observable<Page<PriceChange>> {
    return this.priceChangeService.findByStatus(this.statuses)
      .pipe(tap(priceChanges => this.priceChanges = priceChanges));
  }

  supplierReference(priceChange: PriceChange): SupplierReference | null {
    for (const supplierReference of priceChange.reference.supplierReferences) {
      if (supplierReference.active) {
        return supplierReference;
      }
    }

    throw new Error("no active supplier for reference " + priceChange.reference.isbn);
  }
}